import React from "react";
//import { Navbar } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

// Footer ahora mismo comentado ya que teniamos el fallo de que se pegaba arriba y salía en mitad de la pantalla
const Header = ({mensaje}) => {
  return (
    <div className="d-flex flex-column p-1" style={{alignItems:'center', color:'yellow', backgroundColor:'#ED4749'}} expand="lg">
      <span>{mensaje}</span>
    </div>
  )
}

export default Header;

